const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-start-end",
        label: "계획일자",
        value: "date",
        query: { ss: "startDate", ee: "endDate" },
        options: {
          default: { sd: "", ed: "" },
        },
      },
      {
        component: "search-select-field",
        label: "사업장",
        value: "field",
        query: { f_id: "fieldId", f_name: "fieldName" },
        options: {
          default: { fieldId: "", fieldName: "" },
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["사업장명", "년도", "작업/활동", "환경영향", "계획일자"] },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    //  검색일
    if (search.date) {
      conditions.push({ key: "body.계획일자", operator: ">=", value: search.date.startDate });
      conditions.push({ key: "body.계획일자", operator: "<", value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : "" });
    }

    // 사업장
    if (search.field) {
      conditions.push({ key: "body.stdInfo.field_id", operator: "=", value: search.field.fieldId });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  // =================================================================================================================
  getHead: (tableOptions) => {
    const isQRMode = tableOptions && tableOptions.isQRMode;

    if (isQRMode) {
      return [
        {
          name: "사업장명",
          key: "body.stdInfo.field_name",
          style: { minWidth: "80px" },
        },
        {
          name: "구분",
          key: "", // 일반보수, 돌발보수, 기타
          style: { minWidth: "80px" },
        },
        {
          name: "업체명",
          key: "body.stdInfo.section",
          style: { minWidth: "80px" },
        },
        {
          name: "작업허가명",
          key: "",
          style: { minWidth: "80px" },
        },
        {
          name: "허가번호",
          key: "",
          style: { minWidth: "80px" },
        },
        {
          name: "승인권자<br>(관리감독자)",
          key: "",
          style: { minWidth: "80px" },
        },
        {
          name: "작업장소",
          key: "",
          style: { minWidth: "80px" },
        },
        {
          name: "작업내용",
          key: "",
          style: { minWidth: "80px" },
        },
        {
          name: "입문시간",
          key: "",
          style: { minWidth: "80px" },
        },
        {
          name: "출문시간",
          key: "",
          style: { minWidth: "80px" },
        },
      ];
    }

    return [
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "상태",
        key: "body.상태",
        style: { minWidth: "120px" },
      },
      {
        name: "작성일",
        key: "created_at",
      },
      {
        name: "시작시간",
        key: "", // 일반보수, 돌발보수, 기타
        style: { minWidth: "80px" },
      },
      {
        name: "종료시간",
        key: "", // 일반보수, 돌발보수, 기타
        style: { minWidth: "80px" },
      },
      {
        name: "구분",
        key: "body.구분",
      },
      {
        name: "업체명",
        key: "body.stdInfo.section",
        style: { whiteSpace: "nowrap" },
      },
      {
        name: "작업허가명",
        key: "body.작업정보.작업허가명",
      },
      {
        name: "허가번호",
        key: "body.작업정보.허가번호",
      },
      {
        name: "승인권자<br/>(관리감독자)",
        key: "body.안전관계자.동국제강.이름",
        style: { whiteSpace: "nowrap" },
      },
      {
        name: "작업장소",
        key: "body.작업정보.작업존.label",
      },
      {
        name: "작업내용",
        key: "body.작업정보.작업내용",
      },
      {
        name: "작업유형",
      },
      {
        name: "확인<br/>(안환팀)",
        key: "body.안전관계자.확인자유무",
        style: { whiteSpace: "nowrap" },
      },
      // {
      //   "name": "연장작업",
      //   "key": "body.안전관계자.동국제강.이름",
      //   "style": { whiteSpace: 'nowrap' }
      // },
    ];
  },
  getCol: (index, value, func) => {
    try {
      // const postContent = JSON.parse(value.post_content);
      const content = func.getContent(value);

      const isQRMode = func.isQRMode || false;

      /**
       * QR 코드 테이블에서 표시되는 데이터
       */
      if (isQRMode) {
        const userInfo = func.getAuthUserInfo();
        const me = content.작업자내역.find((e) => e.userId === userInfo.id);

        switch (index) {
          case 0:
            return content.stdInfo.field_name; // 사업장명
          case 1:
            return content.구분;
          case 2:
            return content.stdInfo.section; // 부서명
          case 3:
            return content.작업정보.작업허가명; // 작업허가명
          case 4:
            return content.작업정보.허가번호; // 허가번호
          case 5:
            return content.안전관계자.동국제강.이름; // 승인권자
          case 6:
            return [content.작업정보.작업구역.label, content.작업정보.작업존.label].join("-"); // 작업장소
          case 7:
            return content.작업정보.작업내용; // 작업내용
          case 8:
            return me.입문시간 || "-"; // 입문시간
          case 9:
            return me.출문시간 || "-"; // 출문시간
        }
      }

      switch (index) {
        case 0:
          return content.stdInfo.field_name; // 사업장명
        case 1: {
          const 상태 = content.상태;
          if (상태 === 1) return { type: "colorBox", color: "#00CFE8", text: "등록" };
          else if (상태 === 2) return { type: "colorBox", color: "#FF9F43", text: "입문" };
          else if (상태 === 3) return { type: "colorBox", color: "#EA5455", text: "작업중" };
          else if (상태 === 4) return { type: "colorBox", color: "#28C76F", text: "작업완료" };
          else if (상태 === 5) return { type: "colorBox", color: "#3C3C3C", text: "출문" };
          else return { type: "colorBox", color: "#3C3C3C", text: "임시" };
        }
        case 2:
          return func.getCreatedDate(value.created_at); // 작성일
        case 3:
          return [content.작업정보.허가신청기간, content.작업정보.작업시간.시작].join(" "); // 시작시간
        case 4:
          return content.작업정보.작업시간.종료; // 종료시간
        case 5:
          return content.구분;
        case 6:
          return content.stdInfo.section; // 부서명
        case 7:
          return content.작업정보.작업허가명; // 작업허가명
        case 8:
          return content.작업정보.허가번호; // 허가번호
        case 9:
          return content.안전관계자.동국제강.이름; // 승인권자
        case 10:
          return [content.작업정보.작업구역.label, content.작업정보.작업존.label].join("-"); // 작업장소
        case 11:
          return content.작업정보.작업내용; // 작업내용
        case 12:
          return content.inspectChecked.join(", "); // 작업유형
        case 13:
          return content.안전관계자.확인자유무; // 확인 (안환팀)
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
